<template>
    <a-modal :zIndex="10000" v-if="roiVisible" :visible="roiVisible" :footer="null" width="600px" :maskClosable="false"   @cancel="closeRoiVisible"> 
      <div class="bg-white rounded-lg p-8">
        <!-- 标题区域 -->
        <div class="flex justify-between items-center mb-8">
          <h1 class="text-2xl font-medium text-gray-900">ROI 保本计算器（商家版）</h1>
        </div>

        <!-- 输入区域 -->
        <div class="space-y-6">
          <div class="space-y-2">
            <label class="block text-sm text-gray-700">商品售价(单位元)</label>
            <div class="relative">
              <a-input-number
                v-model="discount_lower_price"
                :min="0"
                :precision="2"
                class="w-full !rounded-button"
                placeholder="请输入商品售价"
              >
                <template #addonAfter>(元)</template>
              </a-input-number>
            </div>
          </div>

          <div class="space-y-2">
            <label class="block text-sm text-gray-700">总成本(含运费)(单位元)</label>
            <div class="relative">
              <a-input-number
                v-model="commission_rate"
                :min="0"
                class="w-full !rounded-button"
                placeholder="请输入商品成本"
              >
                <template #addonAfter>(元)</template>
              </a-input-number>
            </div>
          </div>

          <div class="space-y-2">
            <label class="block text-sm text-gray-700">退货率</label>
            <div class="relative flex items-center gap-4">
              <a-input-number
                v-model="return_rate"
                :min="0"
                :max="100"
                class="w-full !rounded-button"
                placeholder="请输入退货率"
              >
                <template #addonAfter>(百分比)</template>
              </a-input-number> %
              <a-icon type="question-circle"   @click="returnRateVisible=true"/>
            </div>
          </div>

          <div class="space-y-2">
            <label class="block text-sm text-gray-700">平台服务费</label>
            <div class="relative flex items-center gap-4">
              <a-input-number
                v-model="service_fee_rate"
                :min="0"
                :max="100"
                class="w-full !rounded-button"
                placeholder="请输入平台服务费"
              >
                <template #addonAfter>(百分比)</template>
              </a-input-number>
              %
            </div>
          </div>


        </div>

        <!-- 计算结果区域 -->
        <div class="mt-8 space-y-6">
          <div class="bg-gray-50 p-4 rounded-lg">
            <div class="flex justify-between items-center">
              <div>
                <div class="text-sm text-gray-500">预估收益</div>
                <div class="mt-1">
                  <span class="text-orange-500">预估佣金：{{ (discount_lower_price - commission_rate).toFixed(2) }} 元</span>
                  <span class="mx-2 text-gray-300">|</span>
                  <span class="text-green-500">结算佣金：{{ (discount_lower_price - commission_rate  - discount_lower_price*service_fee_rate/100 ).toFixed(2) }} 元</span>
                </div>

                <div class="mt-1">
                  <span class="text-orange-500">毛利润率: {{ getMll() }} %</span>
                  <span class="mx-2 text-gray-300">|</span>
                  <span class="text-green-500">纯利润率：{{ getCll() }} % </span>
                </div>

              </div>
            </div>
          </div>

          
          <div class="space-y-4">
            <div class="flex justify-between items-center">
              <span class="text-sm text-gray-600">预估 ROI：</span>
              <span class="text-green-500 font-medium"> {{ getRoi() }} </span>
            </div>
            <div class="flex justify-between items-center">
              <span class="text-sm text-gray-600">保本 ROI：</span>
              <span class="text-green-500 font-medium"> {{ getBbRoi() }} </span>
            </div>
          </div>

          <div class="space-y-3">
            <div class="text-sm text-gray-600">建议出价：</div>
            <div class="space-y-2">
              <div class="flex justify-between">
                <span class="text-sm text-gray-500">保守出价：</span>
                <span class="text-green-500">{{ getBsBid() }} 元以下</span>
              </div>
              <div class="flex justify-between">
                <span class="text-sm text-gray-500">稳妥出价：</span>
                <span class="text-green-500">{{ getBsBid() }} ~ {{ getWtBid() }} 元 </span>
              </div>
              <div class="flex justify-between">
                <span class="text-sm text-gray-500">激进出价：</span>
                <span class="text-green-500">{{ getWtBid() }}  ~ {{ getJjBid() }} 元</span>
              </div>
            </div>
          </div>


        </div>
      </div>
      <ReturnRate  v-if="returnRateVisible" @closeReturnRateVisible="returnRateVisible=false"/>
    </a-modal>
</template>
  
  <script>  
  import ReturnRate from "./return.vue"
  export default {
    name: 'action',
    props: {
        discount_lower_price: {
            type: Number,
        },
        commission_rate: {
            type: Number,
        },
        return_rate: {
            type: Number,
        },
    },
    data() {
        return {  
          roiVisible: true,
          returnRateVisible:false,
          service_fee_rate:5
        };
    },
  
    components: {
      ReturnRate
    },
  
    watch: {},
    mounted() {
    },
    methods: { 
      getMll(){
        let mll = ((this.discount_lower_price - this.commission_rate)/this.discount_lower_price*100).toFixed(2)
        return mll
      },
      getCll(){
        let cll = ( ( this.discount_lower_price - this.commission_rate - this.discount_lower_price*this.service_fee_rate/100 ) / this.discount_lower_price *100 ).toFixed(2) 
        return cll
      },
      getRoi(){
        let roi = ( this.discount_lower_price/(this.discount_lower_price - this.commission_rate ) ).toFixed(2)
        return roi
      },
      getBbRoi(){
        let z = this.discount_lower_price - this.commission_rate
        let bbRoi =  ( this.discount_lower_price/( z - this.return_rate/100*z - this.service_fee_rate/100*z ) ).toFixed(2)
        return bbRoi
      },
      getBsBid(){
        let bsBid = (this.discount_lower_price - this.commission_rate  - this.discount_lower_price*this.service_fee_rate/100 ).toFixed(2)
        return bsBid
      },
      getWtBid(){ 
        let jjBid = (this.getBsBid()*1.2).toFixed(2)
        return jjBid
      },
      getJjBid(){ 
        let jjBid = (this.getBsBid()*1.5).toFixed(2)
        return jjBid
      },
      closeRoiVisible(){
        this.$emit('closeRoiVisible')
        return;
      }
    },
  };
  </script>
  
  <style lang="less" scoped> 
.dqtitle{
  text-align: center;
  font-weight: 600;
  font-size: 18px;
  color: #fe346e;
  margin-bottom: 20px
}
.dqtag{
  font-size: 14px;
  color: #333;
  text-align: left;
  font-weight: bold;
}
.dqbtn{
  width: 85%;
  margin: 0 auto;
  margin-top: 20px;
  button{
    margin-bottom: 10px;
    width:100%
  }
}
  </style>
  